import React, { Fragment, useContext, useState } from "react";
import moment from "moment";
import CustomizerContext from "../../_helper/Customizer";
import DeleteCoupon from "./DeleteCoupon";
import EditCoupon from "./EditCoupon";
import { Card, CardBody, Col, DropdownItem, Row } from "reactstrap";
import { H3, H5, H6, P } from "../../AbstractElements";
import ActionOptions from "../Common/Component/ActionOptions";

const CouponCards = ({
    tableData,
    fetchTableData,
    onEditClick,
    couponObj,
    setCouponObj
}) => {
    const [deleteId, setDeleteId] = useState("")
    const [deleteModal, setDeleteModal] = useState(false);
    const toggleDeleteModal = () =>
        setDeleteModal(!deleteModal);
    const [editAction, setEditAction] = useState("")
    const [editModal, setEditModal] = useState(false);
    const toggleEditModal = () =>
        setEditModal(!editModal);

    const { mix_background_layout } = useContext(CustomizerContext)


    return (
        <Fragment>
            {tableData.length > 0 ? <Row>
                {
                    tableData.map((data, i) => {
                        return (
                            <Col md='6' key={i} style={{ marginBottom: "30px" }}>
                                <Card style={{ marginBottom: "0px", height: "100%" }}>
                                    <div className="job-search" style={{ height: "100%" }}>
                                        <CardBody>
                                            <div style={{ display: "flex", justifyContent: "space-between",alignItems: "center", marginBottom: "10px" }}>
                                                <H5 attrH5={{ style: { border: "1px dashed", padding: "5px" } }}>{data.code}</H5>
                                                <ActionOptions>
                                                    <Fragment>
                                                        <DropdownItem
                                                            className="border-0"
                                                            key={"row-edit"}
                                                            onClick={() => onEditClick(data)}
                                                        >
                                                            <i className="fa fa-pencil"></i> Edit
                                                        </DropdownItem>
                                                        <DropdownItem
                                                            className="border-0"
                                                            key={"row-edit"}
                                                            onClick={() => {
                                                                if (data?.isDeleted) {
                                                                    setEditAction("recover")
                                                                    setCouponObj(data)
                                                                    toggleEditModal()
                                                                } else {
                                                                    setDeleteId(data?.id)
                                                                    toggleDeleteModal()
                                                                }
                                                            }}
                                                        >
                                                            <i className="fa fa-trash-o"></i> {data?.isDeleted ? "Recover" : "Delete"}
                                                        </DropdownItem>
                                                        <DropdownItem
                                                            className="border-0"
                                                            key={"row-edit"}
                                                            onClick={() => {
                                                                if (data?.isActive) {
                                                                    setEditAction("deactivate")
                                                                } else {
                                                                    setEditAction("activate")
                                                                }
                                                                setCouponObj(data)
                                                                toggleEditModal()
                                                            }}
                                                        >
                                                            <i className="fa fa-ban"></i> {data?.isActive ? "Deactivate" : "Activate"}
                                                        </DropdownItem>
                                                    </Fragment>
                                                </ActionOptions>
                                            </div>
                                            <div className="media">
                                                <div className="media-body">
                                                    <H6 attrH6={{ className: 'f-w-600' }} >
                                                        {data.title}
                                                    </H6>
                                                    <P>{moment(new Date(data.validFrom)).format("MMM DD HH:mm")} - {moment(new Date(data.validUpto)).format("MMM DD HH:mm")}</P>
                                                </div>
                                            </div>
                                            <P>{data.description}</P>
                                        </CardBody>
                                    </div>
                                </Card>

                            </Col>
                        )
                    })
                }
            </Row> : <Card style={{textAlign: "center",padding: "20px 0px"}}>No Coupons found</Card>}
            <DeleteCoupon
                LargeModaltoggle={toggleDeleteModal}
                title={"Delete"}
                Large={deleteModal}
                deleteId={deleteId}
                fetchData={fetchTableData}
            />
            <EditCoupon
                LargeModaltoggle={toggleEditModal}
                title={editAction}
                Large={editModal}
                deleteId={deleteId}
                fetchData={fetchTableData}
                couponObj={couponObj}
                action={editAction}
            />

        </Fragment>
    );
};

export default CouponCards;
